import { createContext } from 'react'

export type BackdropVisibility = { visible: boolean }

export const DialogBackdropContext = createContext<BackdropVisibility>({
  visible: false,
})
